import { Component, input, output, ElementRef, Renderer2, AfterViewInit, OnDestroy, effect, Inject, PLATFORM_ID, inject } from '@angular/core';
import { NgClass, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-form-modal',
  imports: [NgClass ],
  templateUrl: './form-modal.html',
  styleUrl: './form-modal.scss',
})
export class FormModal implements AfterViewInit, OnDestroy {
  isOpen = input<boolean>(false);
  title = input<string>('');
  icon = input<string>('person');
  withHeader = input<boolean>(true);
  withFooter = input<boolean>(true);
  close = output<void>();
  noSpacing = input<boolean>(false);
  btnClass = input<string>('top-4 right-4');
  maxWidthClass = input<string>('max-w-3xl');
  /** Cuando es true, el modal no se cierra al hacer click en el backdrop ni con Escape */
  disableBackdropClose = input<boolean>(false);

  private modalElement: HTMLElement | null = null;
  private platformId = inject(PLATFORM_ID);

  private static zIndexCounter = 50;
  private static openModalsCounter = 0;
  zIndex = 50;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    // Watch for isOpen changes and handle body overflow
    effect((onCleanup) => {
      if (!isPlatformBrowser(this.platformId)) return;
      
      if (this.isOpen()) {
        FormModal.zIndexCounter += 10;
        this.zIndex = FormModal.zIndexCounter;

        // Move modal to body end to ensure it is the last sibling, maximizing z-index context
        if (this.modalElement) {
          this.renderer.appendChild(document.body, this.modalElement);
        }

        FormModal.openModalsCounter++;
        this.renderer.setStyle(document.body, 'overflow', 'hidden');
        
        const keydownListener = this.renderer.listen('document', 'keydown', (event: KeyboardEvent) => {
          if (event.key === 'Escape' && !this.disableBackdropClose()) this.onClose();
        });

        onCleanup(() => {
          keydownListener();
          FormModal.openModalsCounter = Math.max(0, FormModal.openModalsCounter - 1);
          if (FormModal.openModalsCounter === 0) {
            this.renderer.removeStyle(document.body, 'overflow');
          }
        });
      }
    });
  }

  ngAfterViewInit(): void {
    // Move modal to body to escape parent container constraints
    if (isPlatformBrowser(this.platformId)) {
      this.modalElement = this.elementRef.nativeElement;
      if (this.modalElement) {
        this.renderer.appendChild(document.body, this.modalElement);
      }
    }
  }

  ngOnDestroy(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    // Clean up: remove modal from body
    if (this.modalElement && this.modalElement.parentNode) {
      this.renderer.removeChild(document.body, this.modalElement);
    }
  }

  onClose(): void {
    this.close.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (!this.disableBackdropClose() && event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
